export default __webpack_public_path__ + "static/media/gustavo.eb024927.jpeg";